customElements.define('component-chat-widget', class ChatWidget extends HTMLElement {
  constructor() {
    super();
    this.props = {
      chatType: this.getAttribute('chat-type'),
      isChatActive: this.getAttribute('is-chat-active'),
      showFeedbackBtn: this.getAttribute('show-feedback-btn'),
      showFeedbackEnabled: this.getAttribute('show-feedback-enabled'),
    };
    // DOM Elements
    this.chatOverlay = this.querySelector('.js-chat-widget-modal-overlay');
    this.chatButton = this.querySelector('.js-chat-widget-btn');
    this.chatModal = this.querySelector('.js-chat-widget-modal');
    this.chatModalContainer = this.querySelector('.js-chat-widget-modal-container');
    this.chatModalCloseBtn = this.querySelector('.js-chat-widget-modal-close-btn');
    this.liveChatBtn = this.querySelector('.js-chat-widget-modal-live-chat-btn');
    this.feedbackChatBtn = this.querySelector('.js-chat-widget-modal-feedback-chat-btn');
    this.chatModalInfo = this.querySelector('.js-chat-modal-info-available');
    window.addEventListener('load', () => this.initGladly());
    window.addEventListener('configure-gladly', () => this.configureGladly());
  }
  async connectedCallback() {
    this.modalEventListeners();
    this.chatBtnListener();
    if (this.props.isChatActive === 'true') {
      this.liveChatBtn.addEventListener('click', () => {
        this.closeChatModal();
        this.openChat();
      });
    }
  }
  chatBtnListener() {
    this.chatButton.addEventListener('click', () => {
      if (this.props.chatType === 'Chat') {
        this.openChat();
      } else {
        this.chatModal.classList.remove('hidden');
        setTimeout(() => {
          this.chatModalContainer.classList.add('chat-modal-container--open');
        }, 150);
        document.querySelector('body').classList.add('overflow-hidden');
      }
    });
  }
  modalEventListeners() {
    // Close chat modal by button
    this.chatModalCloseBtn.addEventListener('click', () => {
      this.closeChatModal();
    });
    // Close chat modal by clicking outside of modal
    this.chatOverlay.addEventListener('click', (event) => {
      if (event.target.classList.contains('js-chat-widget-modal-overlay')) {
        this.closeChatModal();
      }
    });
    // Close chat modal, open feedback modal
    this.feedbackChatBtn.addEventListener('click', () => {
      this.chatModal.classList.add('hidden');
      document.querySelector('.js-feedback-modal').classList.remove('component-feedback-widget__hidden');
    });
  }
  closeChatModal() {
    this.chatModalContainer.classList.remove('chat-modal-container--open');
    document.querySelector('body').classList.remove('overflow-hidden');
    this.chatModal.classList.add('hidden');
    if (window.useGladlyChat) {
      window.Gladly.show();
    } else {
      window.sierra.closeChatModal();
    }
  }
  openChat() {
    if (window.useGladlyChat) {
      this.openGladlyChat();
    } else {
      window.sierra.openChatModal();
    }
  }

  initGladly() {
      window.Gladly.init({autoShowButton: false, appId: "thirdlove.com"}).then(() => {
        window.theme.chat = {
          isOnline: this.props.isChatActive
        }
        this.configureGladly();
      }).catch((error) => {
        console.error('Gladly init failed!', error);
      })
  }

  configureGladly() {
    if (window.useGladlyChat && window.Gladly.getAvailability) {
      const availableStatus = 'AVAILABLE';
      const chatNotAvailable = window.Gladly.getAvailability().toUpperCase() !== availableStatus;
      if (chatNotAvailable) {
        this.chatModalInfo.classList.remove('hidden');
      }
      if (this.props.isChatActive === 'false' && this.props.showFeedbackBtn === 'false' && this.props.showFeedbackEnabled === 'true') {
        this.chatModalInfo.classList.add('hidden');
      }

      window.Gladly.on("availability:change", (availability) => {
        if (availability.toUpperCase() === availableStatus) {
          this.chatModalInfo.classList.add('hidden');
        } else {
          this.chatModalInfo.classList.remove('hidden');
        }
      });
    }
  }

  openGladlyChat() {
    try {
      const customerEmail =  window.theme.customer.email;
      const customerName =  window.theme.customer.name;
      const gladlyUser = window.Gladly.getUser();
      if (customerEmail && customerName) {
        if (gladlyUser === undefined || gladlyUser.identity !== customerEmail) {
          window.Gladly.clearUser()
            .then(() => {
              window.Gladly.setUser({
                name: customerName,
                email: customerEmail
              });
            });
        } else {
          window.Gladly.clearUser();
        }
      }
    } catch (e) {
      console.warn('The Gladly user could not be configured automatically.', e);
    }
    window.Gladly.show();
  }
});
